export const getTargetLanguage = (preferred_language) => {
    const isPt = preferred_language === "pt" || (preferred_language == null && navigator.language.includes("pt"));
    const targetLanguage = isPt ? 'pt' : 'en';

    return targetLanguage;
};